module.exports = __webpack_public_path__ + "static/media/booking-main-good.a324ce52.svg";